import React from "react";
import "./UpdateMedia.css";

const updates = [
  {
    id: 1,
    date: "10-3-2025",
    title:
      '"We educate women because it is smart. We educate women because it changes the world." Drew Faust.',
    description:
      "Momoi's journey exemplifies the mission of the Maasai Girls Rescue Center, where she and over 70 other Maasai girls have found a nurturing environment that empowers them through quality education...",
    videoId: "F0rWdvJxtEg",
  },
  {
    id: 2,
    date: "10-3-2025",
    title: "Maasai Girls Rescue Center - Tanzania",
    description:
      "As we continue to mark International Women's Day, we celebrate the resilience and potential of Maasai girls through the inspiring story of Momoi Daniely, a resident at the Maasai Girls Rescue Center in Tanzania.",
    videoId: "Fh5GENKLGaM",
  },
  {
    id: 3,
    date: "14-1-2026",
    title: "THE FUTURE IS HERS – Sylvia’s Story | Kisii, Kenya",
    description:
      "Healthcare does more than heal bodies, it restores dignity, unlocks potential, and keeps hope alive. For Sylvia, a young girl from Kisii, Kenya, access to quality healthcare made all the difference.",
    videoId: "9X-C8kK68EM?si=hjkNHc_o2es_2Efk",
  }
];

const UpdatesMedia = () => {
  return (
    <section className="updates-media">
      <h2 className="section-title">
        These films are funded by the IMPACT STORIES FUND.
      </h2>
      <div className="updates-grid">
        {updates.map((update) => (
          <div className="update-card" key={update.id}>
            <div className="video-container">
              <iframe
                className="update-video"
                src={`https://www.youtube.com/embed/${update.videoId}`}
                allowFullScreen
                title={update.title}
              ></iframe>
            </div>
            <p className="update-date">{update.date}</p>
            <h3 className="update-title">{update.title}</h3>
            <p className="update-desc">{update.description}</p>
            <a
              href={`/impact/${update.id}`}
              className="read-more text-decoration-none"
            >
              Read More
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default UpdatesMedia;
